import { api } from './api';

export interface TaskStats {
  total: number;
  not_started: number;
  in_progress: number;
  done: number;
}

export interface DeadlineItem {
  id: string;
  title: string;
  reference_id: string;
  end_date: string | null;
}

export interface GoalProgress {
  id: string;
  title: string;
  reference_id: string;
  progress: number;
  due_date: string;
}

export interface WorkspaceUsage {
  members: number;
  groups: number;
  goals: number;
  sprints: number;
  tasks: number;
}

export interface PerformanceSummary {
  final_score: number;
  rank: number | null;
}

export interface DashboardData {
  task_stats: TaskStats;
  my_active_tasks: number;
  upcoming_deadlines: DeadlineItem[];
  overdue_count: number;
  goal_progress: GoalProgress[];
  usage: WorkspaceUsage | null;
  performance: PerformanceSummary | null;
}

export const dashboardService = {
  getDashboard: () => api.get<{ success: boolean; data: DashboardData }>('/dashboard'),
};
